import React from 'react';
import { Provider } from 'react-redux';

import { ThemeProvider } from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import theme from '../common/themes/theme';
import store from './store';
import AppRouter from './AppRouter';

import Spinner from '../common/components/spinner';
import SnackbarNotification from '../common/components/notification';
// import useAppendScript from '../utils/appendScript';

const App: React.FC = () => {
  // Run scripts here.
  // useAppendScript('https://code.jquery.com/jquery-3.3.1.min.js', true);

  return (
    <>
      <CssBaseline />
      <Spinner />
      <SnackbarNotification />
      <AppRouter />
    </>
  );
};

export default () => (
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </MuiThemeProvider>
);
